export enum MessageType {
  NOTIFICATION = 'notification',
  NOTIFICATION_NEWS = 'notification_news',
  LEADS = 'leads',
}

export enum Events {
  CREATE = 'create',
  UPDATE = 'update',
}

export enum SocketPagePath {
  LEADS = 'leads',
  LEAD_DETAIL = 'lead_detail'
}
